import StudentPage from './StudentPage.container';

export default StudentPage;
